import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    button: 'Contact support',
    text: 'We are sorry, an error occurred while creating your referral code.',
  },
  fr: {
    button: 'Contacter le support',
    text: 'Nous sommes désolé, une erreur est survenue lors de la création de votre code de parrainage.',
  },
} as const);
